import React from 'react';
import './App.scss';
import Header from './components/Header/Header';
import { withRouter } from 'react-router-dom';

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <Header />

        {this.props.children}
      </div>
    );
  }
}

export default withRouter(App);
